import React from 'react';
import { Row, Col, Table } from 'antd';
import { I18n } from '@aws-amplify/core';

import { Title } from '@/components/Typography';
import { useGetBeraNoENSTasks } from '@/hooks/useGetBeraNoENSTasks';
import { useApplicationContext } from '@/context/v1/Application/context';

import type { NoENSTask } from '@/types/Bera';
import type { ColumnsType } from 'antd/lib/table';
import * as S from './styles';

interface NoENSTasksProps {
	bera_job_summary_id: string;
}

export function NoENSTasks({ bera_job_summary_id }: Readonly<NoENSTasksProps>): JSX.Element {
	const { organization, company } = useApplicationContext();

	const { isLoading, data } = useGetBeraNoENSTasks({
		organization_id: organization?.id!,
		company_id: company?.id!,
		id: bera_job_summary_id,
		limit: 5,
		offset: 1,
		min_rpn: -1
	});

	const columns: ColumnsType<NoENSTask> = [
		{
			title: I18n.get('Position'),
			key: 1,
			align: 'center',
			render: (data) => data.position
		},
		{
			title: I18n.get('TLID'),
			key: 2,
			ellipsis: true,
			align: 'center',
			render: (data) => data.task.name
		},
		{
			title: I18n.get('Risk factor'),
			key: 3,
			ellipsis: true,
			align: 'center',
			responsive: ['md'],
			render: (data) => I18n.get(data.custom_report_step_key.description)
		},
		{
			title: I18n.get('RPN'),
			key: 4,
			align: 'center',
			render: (data) => data.task_rpn
		}
	];

	return (
		<Col span={22} style={{ marginTop: '1rem' }}>
			<Row justify="start" style={{ marginBottom: '1rem' }}>
				<Title level={5}>{I18n.get('Highest Risk Factors')}</Title>
			</Row>
			<S.CustomTable span={24}>
				<Table
					rowKey="id"
					columns={columns}
					loading={isLoading}
					dataSource={data?.rows}
					pagination={false}
				/>
			</S.CustomTable>
		</Col>
	);
}
